import { Flex, type ListRef, Spinner } from '@banhala/ui-kit';
import { AtomicRenderer } from 'shared/src/component';
import { useGetScreensInfiniteQuery } from './queries/useGetScreensInfiniteQuery';
import { StyleSheet, View } from 'react-native';
import { useRef } from 'react';
import type { IScreensComponent } from 'shared/src/api';
import { useScrollToFilterList } from './hooks/useScrollToFilterList';
// import type { AtomicRendererRefCurrent } from 'screens/src/components/types';

export type AtomicRendererRefCurrent = ListRef<IScreensComponent>;

export const HomeAtomic: React.FC<{
  screenName: string;
  nextToken?: string;
}> = props => {
  const atomicRendererRef = useRef<AtomicRendererRefCurrent>(null);
  const { data, fetchNextPage, isFetching, refetch } =
    useGetScreensInfiniteQuery(props.screenName, props.nextToken);
  const { filterListIndex, scrollToFilterList } = useScrollToFilterList({
    atomicRendererRef,
    components: data?.components,
  });
  if (!data) {
    return null;
  }

  return (
    <Flex flex={1}>
      {isFetching && (
        <View style={styles.spinnerContainer}>
          <Spinner size={20} />
        </View>
      )}
      <AtomicRenderer
        refetch={refetch}
        data={data ?? []}
        fetchNextPage={fetchNextPage}
        listRef={atomicRendererRef}
        filterListIndex={filterListIndex}
        scrollToFilterList={scrollToFilterList}
        isFetching={isFetching}
      />
    </Flex>
  );
};
const styles = StyleSheet.create({
  spinnerContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: [{ translateX: -10 }, { translateY: -10 }],
    zIndex: 1000,
  },
});
